document.addEventListener('DOMContentLoaded', () => {
    const newUrl = "https://cdn.shopify.com/s/files/1/0976/9094/3834/files/courtney-cook-SsIIw_MET0E-unsplash.jpg?v=1758904185&width=1200"
  const golfball = document.querySelector('.golfball-wrapper');
  const heroImg  = document.getElementById('hero-main-image');
  if (!golfball || !heroImg) return;

  const hoverSrc       = newUrl; // the full CDN url
  const originalSrc    = heroImg.src;
  const originalSrcset = heroImg.srcset;

  // if the url already has a ?, use & before width
  const joiner = hoverSrc.includes('?') ? '&' : '?';

  const hoverSrcset = `
    ${hoverSrc}${joiner}width=832 832w,
    ${hoverSrc}${joiner}width=1200 1200w,
    ${hoverSrc}${joiner}width=1600 1600w,
    ${hoverSrc}${joiner}width=1920 1920w,
    ${hoverSrc}${joiner}width=2560 2560w,
    ${hoverSrc}${joiner}width=3840 3840w
  `;
 golfball.addEventListener('mouseenter', () => {
    heroImg.src = `${hoverSrc}${joiner}width=1200`;
    heroImg.classList.add('hero-zoom');     // 🔑 add zoom class
    heroImg.srcset = hoverSrcset;
  });

  golfball.addEventListener('mouseleave', () => {
    heroImg.src = originalSrc;
    heroImg.srcset = originalSrcset;
    heroImg.classList.remove('hero-zoom');  // 🔑 remove zoom class
  });
});
